/**
 * Edito Product Manager - Moon Moon Agency
 * Section MM-Edito-Product : carrousel image natif (mode Résultat) + mini
 * sélecteur de taille autonome (met à jour le prix affiché, la pastille
 * -X% VS NEUF, la mention Alma et le variant_id caché — sans form panier).
 */

/* Garde de chargement unique : la section peut être présente plusieurs fois
   sur une même page (2 instances = 2 <script src="mm_edito_product.js">),
   et le second chargement redéclarait `const EditoProductManager`, ce qui
   levait une SyntaxError fatale et cassait le JS de toute la page. */
if (!window.EditoProductManager) {

/*********************************************************************************************
 * 🛏️ EDITO PRODUCT MANAGER
 */
window.EditoProductManager = {
	config: {
		selectors: {
			section: '[data-mm-section-handle="mm-edito-product"]',
			carousel: '[data-ep-carousel]',
			track: '[data-ep-track]',
			prev: '[data-ep-prev]',
			next: '[data-ep-next]',
			size: '[data-ep-size]',
			sizeDetails: '.mm-edito-product__size-dd',
			sizeValue: '[data-ep-size-value]',
			sizeBadge: '[data-ep-size-badge]',
			variantOption: '[data-ep-variant]',
			selectedVariant: '[data-ep-selected-variant]',
			price: '.mm-product-price[data-price]',
			marketWrap: '.mm-market-price',
			marketValue: '[data-market-price]',
			percentage: '[data-price-percentage]',
			percentageText: '[data-price-percentage-text] .mm-label-text',
			alma: '[data-ep-alma]',
			almaText: '[data-ep-alma-text]',
			cta: '.mm-edito-product__cta',
		},
	},

	initialized: false,

	init() {
		const sections = window.getElements(this.config.selectors.section);
		if (!sections.length) return; // Guard clause

		if (!this.initialized) {
			this._bindEvents();
			this.initialized = true;
		}

		window.log('info', '🛏️ [EDITO_PRODUCT]', 'Initialized', { sections: sections.length });
	},

	_bindEvents() {
		const s = this.config.selectors;

		document.addEventListener('click', (e) => {
			// --- Flèches carrousel ---
			const prevBtn = e.target.closest(s.prev);
			if (prevBtn) {
				this._scrollCarousel(prevBtn.closest(s.carousel), -1);
				return;
			}
			const nextBtn = e.target.closest(s.next);
			if (nextBtn) {
				this._scrollCarousel(nextBtn.closest(s.carousel), 1);
				return;
			}

			// --- Choix d'une taille ---
			const option = e.target.closest(s.variantOption);
			if (option) {
				e.preventDefault();
				this._selectVariant(option);
				return;
			}
		});
	},

	/**
	 * Fait défiler la piste d'une largeur visible.
	 * @param {HTMLElement} carousel
	 * @param {number} direction - -1 (précédent) ou 1 (suivant)
	 */
	_scrollCarousel(carousel, direction) {
		if (!carousel) return;
		const track = carousel.querySelector(this.config.selectors.track);
		if (!track) return;
		track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
	},

	/**
	 * Applique la variante choisie : libellé, variant_id caché, prix, pastille, Alma.
	 * @param {HTMLElement} option - Le bouton [data-ep-variant] cliqué
	 */
	_selectVariant(option) {
		if (option.getAttribute('aria-disabled') === 'true') return;

		const s = this.config.selectors;
		const sizeBlock = option.closest(s.size);
		const card = option.closest('.mm-edito-product__card');
		if (!sizeBlock || !card) return;

		const price = option.dataset.price || '';
		const market = option.dataset.market || '';
		const percentage = option.dataset.percentage || '';
		const alma = option.dataset.alma || '';
		const title = option.dataset.title || '';
		const badge = option.dataset.badge || '';
		const variantId = option.dataset.variantId || '';

		// État sélectionné dans la liste
		sizeBlock.querySelectorAll(s.variantOption).forEach((opt) => {
			opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
		});

		// Libellé + badge du trigger, puis fermeture du <details>
		const valueEl = sizeBlock.querySelector(s.sizeValue);
		if (valueEl) valueEl.textContent = title;
		const badgeEl = sizeBlock.querySelector(s.sizeBadge);
		if (badgeEl) badgeEl.innerHTML = badge;
		const details = sizeBlock.querySelector(s.sizeDetails);
		if (details) details.open = false;

		// variant_id caché
		const hidden = sizeBlock.querySelector(s.selectedVariant);
		if (hidden) hidden.value = variantId;

		const cta = card.querySelector(s.cta);
		if (cta && cta.hasAttribute('href') && variantId) {
			const url = new URL(cta.getAttribute('href'), window.location.origin);
			url.searchParams.set('variant', variantId);
			cta.setAttribute('href', `${url.pathname}${url.search}`);
		}

		// Prix affiché (span .mm-product-price)
		const priceEl = card.querySelector(s.price);
		if (priceEl && price) {
			priceEl.textContent = price;
			priceEl.dataset.price = price;
		}

		const marketWrap = card.querySelector(s.marketWrap);
		const marketValue = card.querySelector(s.marketValue);
		if (marketWrap && marketValue) {
			marketWrap.hidden = !market;
			if (market) marketValue.textContent = market;
		}

		const percentageEl = card.querySelector(s.percentage);
		const percentageText = card.querySelector(s.percentageText);
		if (percentageEl && percentageText) {
			percentageEl.hidden = !percentage;
			if (percentage) percentageText.textContent = percentage;
		}

		// Mention Alma : reconstruit à partir du template (data-ep-alma-tpl)
		const almaWrap = card.querySelector(s.alma);
		const almaText = card.querySelector(s.almaText);
		if (almaWrap && almaText && alma) {
			const tpl = almaWrap.dataset.epAlmaTpl || '';
			almaText.textContent = tpl ? tpl.replace('__AMOUNT__', alma) : almaText.textContent;
		}

		window.emit('global:edito-product-variant-changed', { variantId, title });
		window.log('info', '🛏️ [EDITO_PRODUCT]', 'Variant changed', { variantId, title });
	},
};

/*********************************************************************************************
 * 🚀 AUTO-INIT
 */
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => window.EditoProductManager.init());
} else {
	window.EditoProductManager.init();
}

document.addEventListener('shopify:section:load', () => window.EditoProductManager.init());

}
